<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="title"
      center
      width="600px"
      :before-close="$onClose"
      destroy-on-close
    >
      <div>
        <h4>导入名单格式：</h4>
        <div class="upload-hint">必填项：uid，学号，工作状态，是否深造，校友类别，会员类别，性别</div>
        <div>荣誉校友需额外录入：身份证号码</div>
        <div>staff需额外录入：邮箱</div>
        <div>若该账号需作为子账号存在，则必须填写主账号UID</div>
      </div>
      <el-upload
        class="upload-wrap"
        :data="{ token: tokenValue }"
        name="excel"
        drag
        :on-error="$onUploadFail"
        :on-success="$onUpload"
        :auto-upload="true"
        :limit="1"
        :action="form_action_update_student_by_excel"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
      </el-upload>
      <p class="upload-wrap-text">
        请下载模版并填写信息,只能上传xls/xlsx文件,且不超过2Mb
      </p>
      <div class="download_template">
        <el-button size="small" @click="downloadXlsx()">下载模版</el-button>

        <el-form id="from_importExcel" method="post">
          <input
            type="input"
            name="token"
            class="from_input_style"
            :value="tokenValue"
          />
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as CApi from "@/api/constant_api.js";

export default {
  data() {
    return {
      form_action_update_student_by_excel:
        URL_PATH + CApi.api_updateStudentByExcel,
      form_action_download_example:
        URL_PATH + "api/adminIndex/downloadOtherExample",

      changVisible: false,
      title: "通过Excel导入信息",
      tokenValue: localStorage.getItem("token"),
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    // 导出xlsx数据
    downloadXlsx: function () {
      document.getElementById("from_importExcel").action =
        this.form_action_download_example;
      document.getElementById("from_importExcel").submit();
    },
    $onUpload(res, file, fileList) {
      console.log(res, file, fileList);
      if (res.Code == 0) {
        this.$message({
          message: "导入Excel成功",
          type: "success",
        });
        this.changVisible = false;
      } else {
        this.$message.error(res.Msg);
      }
    },
    $onUploadFail(res, file, fileList) {
      console.log(res, file, fileList);
    },
    //页面初始化时加载的事件
    init() {
      this.changVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
ul,
ol {
  list-style: decimal;
}
.upload-wrap {
  text-align: center;
  margin-top: 30px;
}
.upload-hint{
  margin-top: 10px;
}
.upload-wrap-text {
  font-size: 14px;
  color: #989898;
  text-align: center;
  margin-top: 10px;
}
.tips {
  font-size: 16px;
  line-height: 1;
  text-align: center;
  color: #000000;
  margin-top: 60px;
  margin-bottom: 35px;
}
.format_description {
  float: left;
  margin-left: 40px;
}
.download_template {
  font-size: 20px;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/importExcelDialog.vue